<script setup lang="ts">
import { IonModal, IonHeader, IonToolbar, IonTitle, IonContent } from '@ionic/vue'

defineProps<{
	show: boolean
	title: string
}>()

const emits = defineEmits(['close'])
</script>

<template>
	<ion-modal :is-open="show" @did-dismiss="emits('close')">
		<ion-header>
			<ion-toolbar>
				<ion-title>{{ title }}</ion-title>
				<ion-buttons slot="end">
					<span class="text-primary cursor-pointer mr-2" @click="emits('close')">Close</span>
				</ion-buttons>
			</ion-toolbar>
		</ion-header>
		<ion-content class="ion-padding">
			<slot />
		</ion-content>
	</ion-modal>
</template>
